export const GET_ALL_BONG_REQUEST = "GET_ALL_BONG_REQUEST";
export const GET_ALL_BONG_SUCCESS = "GET_ALL_BONG_SUCCESS";
export const GET_ALL_BONG_FAIL = "GET_ALL_BONG_FAIL";

export const GET_BONG_REQUEST = "GET_BONCOMMANDE_REQUEST";
export const GET_BONCOMMANDE_SUCCESS = "GET_BONCOMMANDE_SUCCESS";
export const GET_BONCOMMANDE_FAIL = "GET_BONCOMMANDE_FAIL";

export const ADD_BONG_REQUEST = "ADD_BONG_REQUEST";
export const ADD_BONG_SUCCESS = "ADD_BONG_SUCCESS";
export const ADD_BONG_FAIL = "ADD_BONG_FAIL";

export const UPDATE_BONG_REQUEST = "UPDATE_BONG_REQUEST";
export const UPDATE_BONG_SUCCESS = "UPDATE_BONG_SUCCESS";
export const UPDATE_BONG_FAIL = "UPDATE_BONG_FAIL";

export const DELETE_BONG_REQUEST = "DELETE_BONG_REQUEST";
export const DELETE_BONG_SUCCESS = "DELETE_BONG_SUCCESS";
export const DELETE_BONG_FAIL = "DELETE_BONG_FAIL";

export const ADD_BNARTICLE_REQUEST = "ADD_BNARTICLE_REQUEST";
export const ADD_BNARTICLE_SUCCESS = "ADD_BNARTICLE_SUCCESS";
export const ADD_BNARTICLE_FAIL = "ADD_BNARTICLE_FAIL";

export const UPDATE_BNARTICLE_REQUEST = "UPDATE_BNARTICLE_REQUEST";
export const UPDATE_BNARTICLE_SUCCESS = "UPDATE_BNARTICLE_SUCCESS";
export const UPDATE_BNARTICLE_FAIL = "UPDATE_BNARTICLE_FAIL";

export const DELETE_BNARTICLE_REQUEST = "DELETE_BNARTICLE_REQUEST";
export const DELETE_BNARTICLE_SUCCESS = "DELETE_BNARTICLE_SUCCESS";
export const DELETE_BNARTICLE_FAIL = "DELETE_BNARTICLE_FAIL";
